import React from "react";

import "./Spinner.css";

function Spinner() {
  return (
    <div className="react_spinner_container">
      <div className="react_spinner"></div>
    </div>
  );
}

export default Spinner;
